module.exports = __webpack_public_path__ + "static/media/button-start.8c96222e.png";